import React from 'react';


export const NotificationDot:React.FunctionComponent<{children?: any}> = ({children}) => {
  return (
    <div className="notification-dot">{children}</div>
  )
}
